import React from 'react';
import styled from 'styled-components';
import { Z_INDEX } from '../../constants/zIndex';

export interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

function Drawer({ isOpen, onClose, children }: DrawerProps) {
  return (
    <>
      <Backdrop isOpen={isOpen} onClick={onClose} />
      <DrawerContainer isOpen={isOpen}>
        {children}
      </DrawerContainer>
    </>
  );
}

export default Drawer;

const Backdrop = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${Z_INDEX.DRAWER_OVERLAY};

  background: rgba(0, 0, 0, 0.5);
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

const DrawerContainer = styled.aside<{ isOpen: boolean }>`
  z-index: ${Z_INDEX.DRAWER_CONTENT};
  position: fixed;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  box-shadow: -2px 0 1px rgba(104, 104, 104, 0.5);
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;

  background-color: ${props => props.theme.colors.background};
  padding: 10px;
`;


